import Notifications from "./Notifications.vue";

const NotificationStore = {
  state: [], // here the notifications will be added

  removeNotification(timestamp) {
    const indexToDelete = this.state.findIndex(n => n.timestamp === timestamp);
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1);
    }
  },
  addNotification(notification) {
    notification.timestamp = new Date();
    notification.timestamp.setMilliseconds(
      notification.timestamp.getMilliseconds() + this.state.length
    );
    this.state.push(notification);
  },
  notifyM(notification) {
    if (Array.isArray(notification)) {
      notification.forEach(notificationInstance => {
        this.addNotification(notificationInstance);
      });
    } else {
      this.addNotification(notification);
    }
  },
  notifyMsg(msg, level = "success") {
    this.notifyM({
      message: msg,
      icon: "add_alert",
      horizontalAlign: "center",
      verticalAlign: "top",
      type: level
    });
  }
};

var NotificationsPlugin = {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          notificationStore: NotificationStore
        };
      },
      methods: {
        notifyM(notification) {
          this.notificationStore.notifyM(notification);
        },
        notifyMsg(msg, level) {
          this.notificationStore.notifyMsg(msg, level);
        }
      }
    });
    Object.defineProperty(Vue.prototype, "$notifyM", {
      get() {
        return this.$root.notifyM;
      }
    });
    Object.defineProperty(Vue.prototype, "$notifyMsg", {
      get() {
        return this.$root.notifyMsg;
      }
    });
    Object.defineProperty(Vue.prototype, "$notifications", {
      get() {
        return this.$root.notificationStore;
      }
    });
    Vue.component("Notifications", Notifications);
  }
};

export default NotificationsPlugin;
